const isBlank = function (str) {
  if (Object.prototype.toString.call(str) === "[object Undefined]") {
    //空
    return true;
  } else if (Object.prototype.toString.call(str) === "[object Number]") {
    return false;
  } else if (
    Object.prototype.toString.call(str) === "[object String]" ||
    Object.prototype.toString.call(str) === "[object Array]"
  ) {
    //字条串或数组
    return str.length == 0 ? true : false;
  } else if (Object.prototype.toString.call(str) === "[object Object]") {
    return JSON.stringify(str) == "{}" ? true : false;
  } else {
    return true;
  }
};

const hasValue = function (val) {
  if (typeof val == "undifined" || val == null) {
    return false;
  }

  return true;
};

function padStr(i) {
  return i < 10 ? "0" + i : "" + i;
}

function formatDate(val) {
  if (val != null) {
    var date = new Date(val);
    return (
      date.getFullYear() +
      "-" +
      padStr(date.getMonth() + 1) +
      "-" +
      padStr(date.getDate())
    );
  }
}

function formatTime(val) {
  if (val != null) {
    var date = new Date(val);
    return date.getHours() + ":" + date.getMinutes();
  }
}

function formatDateWithoutYear(val) {
  if (val != null) {
    var date = new Date(val);
    return padStr(date.getMonth() + 1) + "-" + padStr(date.getDate());
  }
}

// Distinct数组
function dedupe(array) {
  return Array.from(new Set(array));
}

export default {
  isBlank,
  formatDate,
  formatDateWithoutYear,
  formatTime,
  hasValue,
  dedupe,
};
